import { useMemo } from 'react'
import { TeamGroupSummary } from '@numeo/types-main-web-app'

/**
 * The option set for the My Drivers Group filter, built from the driver badges the page already holds.
 *
 * For every role. It used to read the admin-only group list (`GET /team-groups/v1`) and skip it for anyone
 * who was not an owner or admin, so a dispatcher never saw the filter even though their rows were badged with
 * their desk. That list also carries every desk's membership, so it is not something to open up.
 *
 * The badges are the right source: `useDriverGroupBadges('all')` names only the groups of drivers this user may
 * see, so a dispatcher gets the desks they are on, a Dispatch Manager the desks they run, an admin every desk
 * that holds a driver, and a dispatcher on no desk nothing — which hides the control. The SMS inbox builds its
 * desk chips the same way.
 *
 * Sorted by name so the options do not reorder as badges arrive.
 */
export const useDriverTeamGroups = (badges: ReadonlyMap<string, TeamGroupSummary>): TeamGroupSummary[] =>
    useMemo(() => {
        const groups = new Map<string, TeamGroupSummary>()
        for (const group of badges.values()) groups.set(group.id, group)
        return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name))
    }, [badges])
